import { areDatesEqual, isTodaysDate } from './date-picker-utilities';
import { DatePickerDayProps } from './date-picker.types';

const dayContainerClasses = {
  inSelection: 'bg-jungle-50',
  notInSelection: '',
};

const dayClasses = {
  base: 'text-center text-sm select-none h-8 leading-8 w-full',
  disabled: 'bg-gray-100 cursor-not-allowed',
  selected: 'bg-primary rounded-lg text-white font-bold',
  selectionStart: 'bg-primary rounded-l-lg text-white font-bold',
  selectionEnd: 'bg-primary rounded-r-lg text-white font-bold',
  inSelection: 'bg-jungle-50 hover:bg-jungle-100',
  betweenSelection: '',
  notInSelection: 'hover:bg-gray-50 rounded-lg',
  currentMonth: '',
  currentDate: 'border border-primary rounded-lg',
  otherMonth: 'text-gray-600',
};

const GetDatePickerDayClasses = (
  date: Date,
  isRangeSelection: boolean,
  isCurrentMonth: boolean,
  isSelectionStart?: boolean,
  isSelectionEnd?: boolean,
  isBetweenSelection?: boolean,
  isDisabled = false
) => {
  let classes = dayClasses.base + ' ';
  if (isDisabled) {
    classes += dayClasses.disabled;
    return classes;
  }
  if (isSelectionStart && (!isRangeSelection || isSelectionEnd)) {
    classes += dayClasses.selected;
  } else if (isSelectionStart) {
    classes += dayClasses.selectionStart;
  } else if (isSelectionEnd) {
    classes += dayClasses.selectionEnd;
  } else if (isCurrentMonth) {
    classes += dayClasses.currentMonth;
  } else {
    classes += dayClasses.otherMonth;
  }
  if (isTodaysDate(date) && !isSelectionStart && !isSelectionEnd) {
    classes += ' ' + dayClasses.currentDate;
  }
  if (isBetweenSelection) {
    classes += ' ' + dayClasses.inSelection;
  } else if (!isSelectionStart && !isSelectionEnd) {
    classes += ' ' + dayClasses.notInSelection;
  }
  return classes;
};

export const DatePickerDay = (props: DatePickerDayProps) => {
  const { date, selectionStart, selectionEnd, isRangeSelection, isCurrentMonth, toggleSelection, isDisabled } = props;

  const isSelectionStart = selectionStart && areDatesEqual(date, selectionStart);
  const isSelectionEnd = selectionEnd && areDatesEqual(date, selectionEnd);
  const isBetweenSelection = selectionStart && selectionEnd && date > selectionStart && date < selectionEnd;

  const classes = GetDatePickerDayClasses(
    date,
    isRangeSelection,
    isCurrentMonth,
    isSelectionStart,
    isSelectionEnd,
    isBetweenSelection,
    isDisabled
  );
  const containerClasses = isBetweenSelection ? dayContainerClasses.inSelection : dayContainerClasses.notInSelection;

  return (
    <div className={containerClasses}>
      <button
        aria-disabled={isDisabled}
        className={classes}
        onClick={() => {
          if (!isDisabled) toggleSelection(date);
        }}
        aria-label={date.toLocaleDateString()}
      >
        {date.getDate()}
      </button>
    </div>
  );
};
